import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { mapStateToProps, mapDispatchToProps } from '../../Store';
import EnterTicketTabs from './EnterTicketTabs';
import TicketEntryBlurb from './TicketEntryBlurb';
import TicketSamples from './TicketSamples';
import UserLockout from '../../utils/user_lockout';
import siteConfig from '../../promotion_config';

const EnterTicketsPage = ({ actions }) => {
    const regex = siteConfig.ticketLengthRegex;
    // If we have a prepopulated ticket from the scanner, call the Enter Draw Ticket API and go directly to Post Claim
    // Post Claim will handle all the error reporting to the user if there is any.
    const prepopTicket = new URLSearchParams(document.location.search).get('ticketnumber');

    if (prepopTicket && regex && prepopTicket.match(regex)) {
        // If alphanumeric we will consider this ticket a draw otherwise it will be an instant
        const ticketType = /[A-Za-z]/.test(prepopTicket) ? 'draw' : 'instant';

        //All scanned tickets that are of type instant will be automatically entered. Any non-instant tickets will not be automatically entered when scanned
        actions.drawTicketActions.enterDrawTicket({
            ticket_number: prepopTicket,
            //using entry method of manual instead of scan due to ticket service logic specifically with MRB
            entry_method: 'manual',
            ticket_type: ticketType,
        });
        return (
            <Redirect
                to={{
                    pathname: '/post-claim',
                    state: { motive: 'ScanTicket' },
                    motive: 'ScanTicket',
                }}
            />
        );
    } else {
        return (
            <UserLockout>
                <div className='enter-container container'>
                    <div className='row justify-content-center'>
                        <div className='entry-box col-12 col-lg-6'>
                            <EnterTicketTabs prepopulatedTicket={prepopTicket} />
                        </div>
                        <div className='entry-box col-12 col-lg-6'>
                            <TicketEntryBlurb />
                        </div>
                    </div>
                    <TicketSamples />
                </div>
            </UserLockout>
        );
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(EnterTicketsPage);
